import { useState, useEffect } from 'react';
import { Client, Message } from '@stomp/stompjs';

interface WebSocketProps {
  subscribe: string,
}

export default function useWebSocket({ subscribe }: WebSocketProps) {
  const [newMessage, setNewMessage] = useState<any>(null);
  // console.log("to com o status do newmessage", newMessage,subscribe)

  const handleNewMessage = (newMessage: Message) => {
    const message = JSON.parse(newMessage.body)[0];
    setNewMessage(message);
  }

  const client = new Client({
    brokerURL: process.env.REACT_APP_WS_BROKER_URL,
    onConnect: () => {
      // console.log('WebSocket Connected!');

      client.subscribe(subscribe, (message: Message) => {
        // console.log("stomp:" + message);
        // called when the client receives a STOMP message from the server
        if (message.body) {
          // console.log("to no if message.body", message.body)
          handleNewMessage(message);
        } else {
          console.log('');
        }
      });
    },
    connectHeaders: {
      login: String(process.env.REACT_APP_WS_LOGIN),
      passcode: String(process.env.REACT_APP_WS_PASSCODE),
    },
    debug: function (str) {
      // console.log(str);
    },
    onStompError: function (frame) {
      // Will be invoked in case of error encountered at Broker
      // Bad login/passcode typically will cause an error
      // Complaint brokers will set `message` header with a brief message. Body may contain details.
      // Compliant brokers will terminate the connection after any error
      // console.log('Broker reported error: ' + frame.headers['message']);
      // console.log('Additional details: ' + frame.body);
    },
    onDisconnect: () => {
      // console.log("See you next time!");
    },
    reconnectDelay: 3000,
    heartbeatIncoming: 2000, // 4000
    heartbeatOutgoing: 2000, // 4000    
  });

  useEffect(() => {
    client.activate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return {
    // messages,
    newMessage
  }
}